export enum TAB_VALUES {
	CHAT = 'Chat',
	PROMPT_LIBRARY = 'Prompt library',
	CHAT_HISTORY = 'Chat History',
	RECORDS = 'Records',
}

export enum KNOWLEDGE_BASE_OPTION_VALUE {
	OPTION_GENERAL = 'General Chat',
}

export enum KNOWLEDGE_BASE_VALUE {
	OPTION_VALUE_GENERAL = 'chat',
}

export const unLikeResponseOptions = [
	{
		value: 'Inaccurate information or answer',
		label: 'Inaccurate information or answer',
	},
	{
		value: 'Inappropriate content',
		label: 'Inappropriate content',
	},
	{
		value: 'Grammatical or spelling errors',
		label: 'Grammatical or spelling errors',
	},
	{
		value: 'Coherence and relevance issues',
		label: 'Coherence and relevance issues',
	},
	{
		value: 'Processing time or technical issues',
		label: 'Processing time or technical issues',
	},
	{
		value: 'Other',
		label: 'Other',
	},
];

export enum FEEDBACK_FORM_LABEL {
	FEEDBACK_LIKE_DISPLAY_LABEL = 'I liked my response because',
	FEEDBACK_LIKE_DISPLAY_LABEL_YOU = 'You liked this response',
	FEEDBACK_UNLIKE_DISPLAY_LABEL = 'I didn’t like my response because',
	FEEDBACK_UNLIKE_DISPLAY_LABEL_YOU = 'You didn’t like this response',
	FEEDBACK_LIKE_LABEL = 'What did you like about the response? (optional)',
	FEEDBACK_UNLIKE_LABEL = 'What was the issue with the response? How could it be improved? (optional)',
	FEEDBACK_UNLIKE_REASON = 'Select reason',
	FEEDBACK_ERROR_MESSAGE = 'Unable to send feedback',
	FEEDBACK_SUCCESS_ALERT_TITLE = 'Feedback submitted successfully!',
	FEEDBACK_SUCCESS_ALERT_SUB_TITLE = 'Your feedback for the response has been successfully submitted.',
}

export enum BOT_ACTIONS {
	REGENERATE = 'Regenerate',
	COPY = 'Copy',
}

export enum CHAT_USER_OPTIONS {
	USER = 'user',
	BOT = 'bot',
}

export enum TIME_STAMP_OPTIONS {
	DATE = 'date',
	TIME = 'time',
}
export enum CHAT_TYPE_OPTION {
	PROMPT = 'prompt',
	DOC = 'doc',
}
export enum RE_UPLOAD_BTN_LABEL {
	RE_UPLOAD_LABEL = 'Re-upload',
	UPLOADING_LABEL = 'Uploading',
	RE_UPLOAD_SUCCESS_LABEL = 'Successfully re-uploaded',
	CANCEL = 'Cancel',
}

export const UPLOAD_ERROR_LABEL = 'Upload Error';
export const RESOURCES_LABEL = 'Resources';
export const THREAD_HIGHLIGHTS_LABEL = 'Thread highlights';

export const KNOWLEDGE_BASE_ERROR =
	'Unable to retrive knowledge base list. please try later.';

export enum RE_UPLOAD_STATUS {
	UPLOAD_SUCCESS = 'success',
	UPLOAD_FAILED = 'failed',
	RE_UPLOAD_SUCCESS = 're-upload-success',
}

export enum RISK_LINK_CONFIG_TYPE {
	ROLE = 'role',
}

export enum REMOVE_RECORD_BUTTON_TEXT {
	CANCEL = 'Cancel',
	YES = 'Yes',
}

export enum REMOVE_RECORD_MODAL_TITLE {
	TITLE = 'Remove Record',
}

export enum REMOVE_RECORD_MODAL_SUBTITLE {
	SUBTITLE = 'Are you sure you want to remove this record? This action will permanently delete the item.',
}

export const CHAT_RECORD_DELETED_SUCCESS_MESSAGE =
	'Record deleted successfully';
